import { Button, buttonClasses, MenuItem, menuItemClasses } from "@mui/material";
import { styled } from "@mui/material/styles";
import { InfoIcon } from "../../../../assets/icons/Info.js";
import { CallTaskState } from "../../../../call-management.types.js";
import "react/jsx-runtime";
const StatusButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== "isActiveCall" && prop !== "isCallOpen" && prop !== "status"
})(({ theme, isActiveCall, isCallOpen, status }) => ({
  ...theme.typography["Lato Overline Bold"],
  padding: "4px",
  borderRadius: "4px",
  height: "auto",
  "&:focus": {
    background: theme.palette.secondary[400],
    boxShadow: "none"
  },
  [`& .${buttonClasses.startIcon}`]: {
    marginLeft: 0,
    fontSize: "16px",
    "& svg": {
      fontSize: "16px"
    }
  },
  ...isActiveCall && {
    background: theme.palette.secondary[400],
    color: theme.palette.common.white,
    [`&.${buttonClasses.disabled}`]: {
      background: theme.palette.secondary[400],
      color: theme.palette.common.white
    }
  },
  ...isCallOpen && {
    background: theme.palette.warning[50],
    color: theme.palette.warning[800],
    "&:hover": {
      background: theme.palette.warning[100]
    },
    "&:focus": {
      background: theme.palette.warning[50],
      boxShadow: "none"
    },
    [`&.${buttonClasses.disabled}`]: {
      background: theme.palette.warning[50],
      color: theme.palette.warning[800]
    }
  },
  ...status === CallTaskState.Open_InProgress && {
    background: theme.palette.success[200],
    color: theme.palette.success[900],
    [`&.${buttonClasses.disabled}`]: {
      background: theme.palette.success[200],
      color: theme.palette.success[900]
    }
  },
  ...(status === CallTaskState.Done || status === CallTaskState.Done_AvailyBooking) && {
    background: theme.palette.success[50],
    color: theme.palette.success[800],
    [`&.${buttonClasses.disabled}`]: {
      background: theme.palette.success[50],
      color: theme.palette.success[800]
    }
  },
  ...status === CallTaskState.Open_Ringing && {
    background: theme.palette.secondary[400],
    color: theme.palette.common.white,
    [`&.${buttonClasses.disabled}`]: {
      background: theme.palette.secondary[400],
      color: theme.palette.common.white
    }
  },
  ...status === CallTaskState.Ignored && {
    background: theme.palette.grey[200],
    color: theme.palette.grey[700],
    [`&.${buttonClasses.disabled}`]: {
      background: theme.palette.grey[200],
      color: theme.palette.grey[700]
    }
  }
}));
const StatusMenuIcon = styled("span")(({ theme, isIgnore }) => ({
  display: "flex",
  borderRadius: "4px",
  padding: "4px",
  fontSize: "14px",
  marginRight: "4px",
  background: theme.palette.secondary[25],
  color: theme.palette.warning[500],
  ...isIgnore && {
    background: theme.palette.grey[200],
    color: theme.palette.grey[600]
  },
  "& svg": {
    fontSize: "14px"
  }
}));
const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  background: theme.palette.common.white,
  color: theme.palette.grey[800],
  "&:hover": {
    background: theme.palette.primary["50"]
  },
  [`&.${menuItemClasses.selected}`]: {
    background: theme.palette.common.white,
    "&:hover": {
      background: theme.palette.primary["50"]
    }
  }
}));
const StyledInfoIcon = styled(InfoIcon)(({ theme }) => ({
  color: theme.palette.grey[500],
  fontSize: "18px",
  marginLeft: "4px"
}));
const StatusWrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  position: "relative"
}));
export {
  StatusButton,
  StatusMenuIcon,
  StatusWrapper,
  StyledInfoIcon,
  StyledMenuItem
};
